import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CiMenuBurger } from "react-icons/ci";
import { FaCog } from "react-icons/fa";
import settings_icon from "../assets/icons/settings.svg";
import logout_icon from "../assets/icons/logout.svg";

const DashboardNav = ({ onToggleSidebar }) => {
  const [profileMenu, setProfileMenu] = useState(false);

  const handleProfileMenu = () => {
    setProfileMenu(prev => !prev);
  };

  useEffect(() => {
    document.body.style.overflow = profileMenu ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [profileMenu]);

  return (
    <nav className="flex items-center justify-between p-4 bg-white shadow-md shadow-gray-200">
      <div className="flex items-center space-x-4">
        <CiMenuBurger
          className="md:hidden cursor-pointer text-pink-utility"
          size={30}
          onClick={onToggleSidebar}
        />
      </div>
      <div className="relative flex items-center space-x-4">
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={handleProfileMenu}
        >
          <FaCog className="text-gray-600" size={30} />
          <span className="text-main-utility font-medium">Admin Panel</span>
        </div>
        <div
          className={`absolute right-0 mt-12 w-48 bg-white squared-lg shadow-lg z-50 transition-transform ${
            profileMenu ? "scale-100" : "scale-0"
          }`}
        >
          <Link
            to="/dashboard/settings"
            className="flex items-center px-4 py-2 hover:bg-gray-100 squared-t-lg text-main-utility"
            onClick={()=>setProfileMenu(false)}
          >
            <img src={settings_icon} alt="Settings Icon" className="w-5 h-5 mr-2" />
            Account Settings
          </Link>
          <button
            className="flex items-center px-4 py-2 hover:bg-gray-100 w-full text-left squared-b-lg text-main-utility"
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("ID");
              window.location.href = "/";
            }}
          >
            <img src={logout_icon} alt="Logout Icon" className="w-5 h-5 mr-2" />
            Log Out
          </button>
        </div>
      </div>
      <div
        className={`fixed left-0 top-0 h-screen w-screen bg-black opacity-30 z-40 ${
          profileMenu ? "block" : "hidden"
        }`}
        onClick={handleProfileMenu}
      />
    </nav>
  );
};

export default DashboardNav;
